module.exports = __webpack_public_path__ + "static/media/icon-dashboard-pending.ae8108fa.svg";